import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class PostFinalizeService extends BaseApiService {
    public checkFacialRecognitionStatus = (driverCredentialId: number): Observable<{ result: boolean }> => this.post(`Driver/PostFinalize/FacialRecognition/${driverCredentialId}/Check`, null);

    public resendToFacialRecognition = (driverCredentialFolioIds: number[]): Observable<{ result: boolean }> => this.post('driver/postfinalize/facialrecognition/resend', driverCredentialFolioIds);
}
